type PropsType = {
  onClick?: () => void;
};
const PlayIcon = ({
  onClick = () => undefined
}: PropsType) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };
  return <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onClick} onKeyDown={handleKeyDown} role="button" tabIndex={0}>
      <path opacity="0.8" d="M74.29 19.8769C73.15 16.5641 70.87 14.6154 67.64 13.8359C63.08 12.6667 43.7 12.6667 38 12.6667C32.3 12.6667 12.92 12.6667 8.36 13.8359C5.13 14.6154 2.85 16.5641 1.71 19.8769C0 24.7487 0 36.2461 0 38C0 39.7538 0 51.2513 1.71 56.1231C2.85 59.4359 5.13 61.3846 8.36 62.1641C12.92 63.3333 32.3 63.3333 38 63.3333C43.7 63.3333 63.08 63.3333 67.64 62.1641C71.06 61.3846 73.34 59.241 74.48 55.9282C76 51.2513 76 39.7538 76 38C76 36.2461 76 24.7487 74.29 19.8769ZM30.02 48.1333C30.02 41.3128 30.02 34.6872 30.02 27.8667C36.48 31.1795 43.13 34.6872 49.59 38C42.94 41.5077 36.48 44.8205 30.02 48.1333Z" fill="white" />
      <path opacity="0.8" d="M30.02 48.1333C30.02 41.3128 30.02 34.6872 30.02 27.8666C36.48 31.1795 43.13 34.6871 49.59 38C42.94 41.5077 36.48 44.8205 30.02 48.1333Z" fill="#191919" />
    </svg>;
};
export default PlayIcon;